import { render, staticRenderFns } from "./currentDispatch.vue?vue&type=template&id=2ec0415b&scoped=true&"
import script from "./currentDispatch.vue?vue&type=script&lang=js&"
export * from "./currentDispatch.vue?vue&type=script&lang=js&"
import style0 from "./currentDispatch.vue?vue&type=style&index=0&id=2ec0415b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0415b",
  null
  
)

export default component.exports